import axios from 'axios';
window.axios = axios;

// FE must talk to this app over the same origin to avoid mixed-content/CORS
const appBaseUrl = window.location.origin;
window.axios.defaults.baseURL = appBaseUrl;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.headers.common['Accept'] = 'application/json';
window.axios.defaults.withCredentials = true;
// Important: rely on XSRF-TOKEN cookie only (do NOT force X-CSRF-TOKEN header — it can be stale after login/logout)
window.axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
window.axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';

// 419 (Page Expired) handling for axios: refresh XSRF and retry once, then reload
try {
    window.axios.interceptors.response.use(
        (resp) => resp,
        async (error) => {
            const status = error?.response?.status;
            const cfg = error?.config || {};
            if (status === 419 && !cfg.__retry419) {
                try {
                    await fetch(window.location.href, { credentials: 'same-origin', cache: 'no-store' });
                } catch {}
                // Attach fresh XSRF header from cookie
                try {
                    const parts = (document.cookie || '').split(';').map((s) => s.trim());
                    const pair = parts.find((s) => s.startsWith('XSRF-TOKEN='));
                    const val = pair ? decodeURIComponent(pair.split('=')[1] || '') : '';
                    if (val) {
                        cfg.headers = cfg.headers || {};
                        cfg.headers['X-XSRF-TOKEN'] = val;
                    }
                } catch {}
                cfg.__retry419 = true;
                return window.axios.request(cfg);
            }
            if (status === 401 || status === 419) {
                // Fallback: force full reload to refresh session/login
                try { window.location.reload(); } catch {}
            }
            return Promise.reject(error);
        }
    );
} catch {}

// Ensure Inertia (fetch) requests also carry CSRF headers
(() => {
    function readCookie(name) {
        const target = name + '=';
        const parts = document.cookie ? document.cookie.split(';') : [];
        for (let part of parts) {
            part = part.trim();
            if (part.startsWith(target)) return decodeURIComponent(part.slice(target.length));
        }
        return '';
    }

    const origFetch = window.fetch.bind(window);

    window.fetch = async (input, init = {}) => {
        try {
            const url = typeof input === 'string' ? input : (input && input.url) || '';
            const sameOrigin = !/^https?:\/\//i.test(url) || url.startsWith(window.location.origin);
            if (sameOrigin) {
                const attachTokens = (cfg) => {
                    // Always use fresh XSRF cookie; do NOT send X-CSRF-TOKEN from meta to avoid using stale token
                    const xsrfCookie = readCookie('XSRF-TOKEN');
                    const headers = new Headers(cfg.headers || {});
                    if (xsrfCookie) headers.set('X-XSRF-TOKEN', xsrfCookie);
                    if (!headers.has('X-Requested-With')) headers.set('X-Requested-With', 'XMLHttpRequest');
                    return { ...cfg, headers };
                };

                init = attachTokens(init);
                if (!init.credentials) init.credentials = 'same-origin';

                const res = await origFetch(input, init);
                if (res.status === 419 && !init.__retry419) {
                    // Refresh cookies (and thus XSRF token) then retry once
                    await origFetch(window.location.href, { credentials: 'same-origin', cache: 'no-store' });
                    const retryInit = attachTokens({ ...init, __retry419: true });
                    return origFetch(input, retryInit);
                }
                return res;
            }
        } catch (_) {}
        return origFetch(input, init);
    };
})();
